import { render, staticRenderFns } from "./SupportMessage.vue?vue&type=template&id=356a2512&scoped=true&"
import script from "./SupportMessage.vue?vue&type=script&lang=js&"
export * from "./SupportMessage.vue?vue&type=script&lang=js&"
import style0 from "./SupportMessage.vue?vue&type=style&index=0&id=356a2512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a2512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VDataTable})
